<template>
  <ScreenAdapter>
    <div class="drugs flex-column">
      <div class="drugs-top flex-row justify-between">
        <div class="drugs-top-left flex-row align-center">
          <img src="../assets/img/logo.png" alt="" />
          <span style="font-weight:600">看诊医生：<span style="margin-left: 0;" v-html="srtinfor(OrgName)"></span></span>
          <!-- <span>|</span>
        <span>王医生</span> -->
        </div>
        <div
          class="drugs-top-right flex-row align-center flex-shrink"
          id="times"
        >
          {{ timeMsg }}
          <img src="../assets/img/set-bl.png" alt="" @click="goSet" />
        </div>
      </div>
      <div class="drugs-con flex-1 flex-row justify-between">
        <div class="flex-column doctor-con-common">
          <p class="con-common-name02">
            <span style="color: #333;">正在呼叫：</span>
            <span
              v-if="showName.length > 0"
              v-for="(item, index) of showName"
              :key="index"
            >
              {{ item.Remark }}
            </span>
            <span v-else>待叫号</span>
          </p>
          <div class="flex-row sdoctor-cont">
            <ul
              class="con-common-ti flex-row align-center"
              style="background-color:#146db6"
            >
              <li style="width: 200px;">No</li>
              <li>姓名</li>
              <li style="text-align: left;">电话</li>
            </ul>
            <ul
              class="con-common-ti flex-row align-center"
              style="background-color:#146db6;margin-left: 20px;"
            >
              <li style="width: 200px;">No</li>
              <li>姓名</li>
              <li style="text-align: left;">电话</li>
            </ul>
          </div>
          <div class="sdoctor-secttion  flex-1 flex-row">
            <div class="flex-1 sdoctor-seLeft">
              <div class="swiper-container flex-column" style="height: 100%;">
                <DoctorOrderList
                  :list="showFiveList"
                  types="qy"
                  :DataType="DataType"
                />
              </div>
            </div>
            <div class="flex-1 sdoctor-seRight">
              <div
                class="swiper-container flex-column"
                id="swiperRight"
                style="height: 100%;"
              >
                <DoctorOrderList
                  :list="patientList"
                  types="qy"
                  :DataType="DataType"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ScreenAdapter>
</template>

<script>
import ScreenAdapter from '../components/ScreenAdapter'
import DoctorOrderList from '../components/doctorOrderList'
import Swiper from 'swiper'
import Speech from 'speak-tts'
export default {
  components: {
    ScreenAdapter,
    DoctorOrderList
  },
  data () {
    return {
      timeMsg: '', // 时间
      speech: null, // 浏览器语音播报实例
      audioText: '', // 要播放的语音文字
      OrgCode: '', // 组织id
      OrgName: '', // 组织名称
      DataType: 3, // 区分要查询的内容，1待调剂，2待取药，3待调剂和待取药，默认为3全部配置
      DqySilder: 5, // 待取药默认5个
      CashType: '', // 分类
      adjusteList: [], // 待调剂
      medicineList: [], // 待取药
      audioPlayList: [], // 要播放的语音列表
      audioisPlayList: [], // 已经播放的语音列表
      timer: null, // 当前时间定时器
      getOrderTimer: null, // 获取订单定时器
      voiceEnd: true, // 语音是否播放完毕
      leftDataEnd: true, // 获取左边待调剂是否滚动完毕
      rightDataEnd: true, // 获取右边待取药是否滚动完毕
      audioList: [], // 处理后的播放语音列表
      patientList: [], // 当前展示看诊列表
      currentRound: 0, // 播报次数
      totalPlayTimes: 3, // 总的循环播报三次
      palyover: false,
      showFiveList: [], // 展示不滚动的5个人
      mySwiperRight: null, // 右侧swiper实例
      reachEndTimes: 0, //  右侧swiper滚动到最后的次数
      isRequest: false,// 数据小于12条时请求
      showName:'',//显示患者的名字
    }
  },
  mounted () {
    // eslint-disable-next-line no-unused-vars
    let parmas = this.$route.query
    // 路由参数中有组织，查询类别，查询种类参数
    if (JSON.stringify(parmas) !== '{}') {
      this.OrgCode = parmas.OrgCode // 组织id
      //  this.CashType = parmas.CashType // 处方类别
      this.OrgName = parmas.OrgName // 组织名称
      // this.DataType = parmas.DataType || 3 // 查询种类
      // this.DqySilder = this.DataType == 2 ? 8 : 5
    }

    this.getInitDataShow(1)
    this.getInitData(1)
    // 前端定时轮询查询订单数据，1500查询一次
    this.getOrderTimer = setInterval(() => {
      // console.log(this.leftDataEnd)
      // console.log(this.rightDataEnd)
      // 如果分页大于5条，分页完毕再去轮询
      console.log('this.palyover++++++', this.palyover)
      if (this.palyover) {
        this.getInitData(0)
      }
      if (this.isRequest) {
        this.getInitDataShow(0)
      }
      /* if (this.DataType == 2) {
          if (this.rightDataEnd) { // 只查询待取药就不用判断待配药的数据是否加载完毕
            this.getInitData(0)
          }
        } else {
          if (this.leftDataEnd || this.rightDataEnd) {
            this.getInitData(0)
          }
        } */
    }, 10000)
    this.initTime() // 初始化系统时间
    this.speechInit() // 系统语音初始化
  },
  beforeDestroy () {
    // 页面销毁的时候暂停语音，清除页面所有定时器
    this.audioList.forEach(item => {
      item.pause()
    })
    clearInterval(this.timer)
    clearInterval(this.getOrderTimer)
    this.local.removeItem('showNameList');
  },
  methods: {
    srtinfor (str) {
      const result = str.replace(/\(.*?\)/g, '')
      return result
    },
    // 初始化数据
    getInitDataShow (type) {
      this.$http
        .get('/BigCallScreen/CallInfo', {
          params: {
            DoctorCode: this.OrgCode // 组织id
          }
        })
        .then(data => {
          let arr = data.data.Take || [] // 待看诊医生列表
          if (arr.length < 12) {
            this.isRequest = true
          } else {
            this.isRequest = false
          }
          // eslint-disable-next-line eqeqeq
          this.showFiveList = arr.slice(0, 6)
          // 截取剩余部分（若数组长度≤5，则返回空数组）
          this.patientList = arr.slice(6)
          // this.rightDataEnd = this.patientList.length <= 6 // 当待看诊医生数据小于5条，设置轮询标志默认true
          if (!this.mySwiperRight) {
            this.initSwiper()
          } else {
            this.mySwiperRight.updateSlides()
          }
          // eslint-disable-next-line handle-callback-err
          console.log('this.patientList++++', this.patientList)
        })
        .catch(err => {
          // alert('网络异常，请检查网络设置!')
        })
    },
    // 夏师傅语音播报
    getInitData (type) {
      this.$http
        .get('/BigCallScreen/CallSpeek', {
          params: {
            DoctorCode: this.OrgCode // 组织id
          }
        })
        .then(data => {
          let arrlist = data.data.Take || [] // 待取药列表
         console.log('fffffffffffffff');
          if(arrlist.length>0){
            this.local.setItem('showNameList', JSON.stringify(arrlist))
          }
          if(arrlist.length==0){
             let localData = JSON.parse(this.local.getItem('showNameList')) // 获取本地缓存中的配置信息
             this.showName =localData
             this.palyover=true;
          }else{
            this.showName=arrlist
          }

         // showName
          // eslint-disable-next-line eqeqeq
          //  1this.rightDataEnd = this.medicineList.length <= 5 // 当待配药列表数据小于5条，设置轮询标志默认true
          if (this.voiceEnd) {
            this.audioPlayList = data.data.Take || []
            this.audioisPlayList = data.data.Take || []
            console.log('this.audioPlayList', this.audioPlayList)
            this.baiduAuido(this.audioPlayList)
          }
          // eslint-disable-next-line handle-callback-err
        })
        .catch(err => {
          // alert('网络异常，请检查网络设置!')
        })
    },

    // 播报语音
    baiduAuido (medicineList) {
      if (medicineList.length === 0) return
      // this.voiceEnd = false
      this.audioList = []
      let i = -1
      medicineList.forEach(element => {
        // &spd=5 速度 VoiceInfo
        let url =
          'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&per=0&tex=' +
          encodeURI(element.Remark)
        this.audioList.push(new Audio(url))
      })
      this.$nextTick(function () {
        playSnd()
      })
      let _this = this

      function playSnd () {
        i++
        if (i === 3) {
          _this.voiceEnd = true
          _this.palyover = true
          console.log('语音播报完毕12', _this.voiceEnd)
          return
        }
        _this.audioList[i].addEventListener('ended', () => {
          console.log('llllllllllllllllllll')
          _this.currentRound++
          if (_this.currentRound < _this.totalPlayTimes) {
            medicineList.forEach(element => {
              // &spd=5 速度 VoiceInfo
              let url =
                'https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&per=0&tex=' +
                encodeURI(element.Remark)
              _this.audioList.push(new Audio(url))
            })
            playSnd()
          } else {
            _this.currentRound = 0
            _this.palyover = true
          }
          // playSnd
        })
        _this.audioList[i]
          .play()
          .then(data => {
            console.log('支持audio自动播放111111111111111')
            // eslint-disable-next-line handle-callback-err
          })
          .catch(err => {
            for (let i = 0; i < _this.totalPlayTimes; i++) {
              console.log(`开始第 ${i + 1} 轮播报`)
              console.log('++++++++++++++++++++', medicineList.length)
              for (let index = 0; index < medicineList.length; index++) {
                console.log('index_______', index)
                const item = medicineList[index]
                _this.speech
                  .speak({
                    text: item.Remark
                  })
                  .then(() => {})
                if (index === medicineList.length - 1) {
                  console.log('播报完成...000000', _this.currentRound)
                  _this.currentRound++
                  // 3轮全部完成，标记结束
                  if (_this.currentRound === _this.totalPlayTimes) {
                    _this.voiceEnd = true
                    _this.currentRound = 0 // 重置轮次（方便后续再次调用）
                    _this.palyover = true
                  }
                }
              }
            }
          })
      }
    },
    // 系统语音初始化
    speechInit () {
      this.speech = new Speech()
      this.speech.setLanguage('zh-CN')
      this.speech.init().then(() => {
        console.log('语音播报初始化完成...')
      })
    },
    // 跳转设置
    goSet () {
      this.$router.push({
        name: 'doctorSet',
        params: {}
      })
    },
    // 初始化swiper
    initSwiper () {
      let _this = this
      // eslint-disable-next-line no-unused-vars
      this.mySwiperRight = new Swiper('#swiperRight', {
        direction: 'vertical', // 垂直切换选项
        // loop: true, // 循环模式选项
        speed: 1500,
        slidesPerView: 6, // 显示多少个滑块
        slidesPerGroup: 1, // 每次移动滑块每次移动多少个
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 5000
        },
        on: {
          reachEnd: () => {
            if (this.reachEndTimes >= 1) {
              this.reachEndTimes = 0
              this.getInitDataShow(0)
            }
            this.reachEndTimes += 1
          },
          reachBeginning: function (e) {
            //  _this.rightDataEnd = true
          }
        }
      })

      // eslint-disable-next-line no-unused-vars
    },
    // 初始化系统时间
    initTime () {
      this.$http.get('/Sys_Date').then(data => {
        let timeMsg = data.data
        this.timeMsg = this.util.formatDate(
          data.data * 1000,
          'yyyy年MM月dd日'
        )
        this.timer = setInterval(() => {
          timeMsg += 1
          this.timeMsg = this.util.formatDate(
            timeMsg * 1000,
            'yyyy年MM月dd日'
          )
        }, 1000)
      })
    }
  }
}
</script>

<style>
@import url("../assets/css/index.css");
@import url("../assets/css/doctor.css");
</style>



// WEBPACK FOOTER //
// src/pages/doctorDisplay-all.vue